import { render, staticRenderFns } from "./ReportsTeam.vue?vue&type=template&id=619c20fa&"
import script from "./ReportsTeam.vue?vue&type=script&lang=js&"
export * from "./ReportsTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports